import { render, staticRenderFns } from "./SendMessageSettings.vue?vue&type=template&id=51ae2454&scoped=true&"
import script from "./SendMessageSettings.vue?vue&type=script&lang=js&"
export * from "./SendMessageSettings.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageSettings.vue?vue&type=style&index=0&id=51ae2454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae2454",
  null
  
)

export default component.exports